module.exports = __webpack_public_path__ + "static/media/notify.a6aeef64.wav";